/**
 * USB/HID product identifiers paired with GAMESTOP_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */

/**
 * Product identifier (PID) of the GameStop PS4 Fun Controller.
 * Pair with GAMESTOP_VENDOR_ID in the supported-controller filter.
 */
export const GAMESTOP_PS4_FUN_CONTROLLER_PRODUCT_ID = 0x4001
